import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { PublicForm } from '@cloudsign/shared';
import type { PublicFormCreate, PublicFormUpdate as PublicFormUpdateT } from '@cloudsign/shared';
import { z } from 'zod';
import { api } from '../../lib/api';

export const FormList = z.array(PublicForm);
export const formsKey = ['pre-registration', 'forms'] as const;

export function useForms() {
  return useQuery({ queryKey: formsKey, queryFn: () => api.get('/pre-registration/forms', { schema: FormList }) });
}

/** Body types are the shared input types, so a field change in the contract shows up here as a type error. */
export function useSaveForm(editingId: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: z.input<typeof PublicFormCreate> | z.input<typeof PublicFormUpdateT>) =>
      editingId
        ? api.patch(`/pre-registration/forms/${editingId}`, { body, schema: PublicForm })
        : api.post('/pre-registration/forms', { body, schema: PublicForm }),
    onSuccess: () => qc.invalidateQueries({ queryKey: formsKey }),
  });
}

export function useDeleteForm() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete(`/pre-registration/forms/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: formsKey }),
  });
}
